import { Button, FormGroup } from '@blueprintjs/core'
import * as con from "../../GlobalConstants"
import * as XLSX from 'xlsx';
import { AccountsHook, ExposuresHook, ForwardCoveragesHook, OptionCoveragesHook, SpotCoveragesHook } from '../hooks/TransactionsHooks';
import { downloadWorkBook } from '../../utils/downloadFunctions';
import { RefModelParameterHook } from '../hooks/ModelParameterHooks';
import { formatWorkSheet } from '../../utils/excelFunctions';
import { createNotification } from '../../templates/notifications/Notifications';
import { constructFileName } from '../../utils/reportFunctions';
import { exportTransactionsByType } from '../../utils/exportFunctions'; // 👈 nuevo import


function TransactionsDownload() {

    const clientType = RefModelParameterHook(con.CLIENT_TYPE)

    const exposures = ExposuresHook()
    const coveragesFwd = ForwardCoveragesHook()
    const coveragesOption = OptionCoveragesHook()
    const coveragesSpot = SpotCoveragesHook()
    const accounts = AccountsHook()

    const downloadCurrentLine = () => {

      const workbook = XLSX.utils.book_new();

      // Constructs Worksheets
      const exposuresWoorkSheet = formatWorkSheet(XLSX.utils.json_to_sheet(exportTransactionsByType(con.EXPOSURES, exposures)))
      const coveragesFwdWoorkSheet = formatWorkSheet(XLSX.utils.json_to_sheet(exportTransactionsByType(con.COVERAGES_FWD, coveragesFwd)))
      const coveragesOptionWoorkSheet = formatWorkSheet(XLSX.utils.json_to_sheet(exportTransactionsByType(con.COVERAGES_OPTION, coveragesOption)))
      const coveragesSpotWoorkSheet = formatWorkSheet(XLSX.utils.json_to_sheet(exportTransactionsByType(con.COVERAGES_SPOT, coveragesSpot, clientType)))
      const accountsWoorkSheet = formatWorkSheet(XLSX.utils.json_to_sheet(exportTransactionsByType(con.ACCOUNTS, accounts, clientType)))

      // Adds to Book
      XLSX.utils.book_append_sheet(workbook, exposuresWoorkSheet, con.EXPOSURES_SHEET_NAME);
      XLSX.utils.book_append_sheet(workbook, coveragesFwdWoorkSheet, con.COVERAGES_FWD_SHEET_NAME);
      XLSX.utils.book_append_sheet(workbook, coveragesOptionWoorkSheet, con.COVERAGES_OPTIONS_SHEET_NAME);

      if(clientType === con.IMPORTER)
        XLSX.utils.book_append_sheet(workbook, coveragesSpotWoorkSheet, con.COVERAGES_SPOT_SHEET_NAME_IMPORTER);
      else if(clientType === con.EXPORTER)
        XLSX.utils.book_append_sheet(workbook, coveragesSpotWoorkSheet, con.COVERAGES_SPOT_SHEET_NAME_EXPORTER);
      else
        throw new Error(`No support for client type: ${clientType}`)   

      XLSX.utils.book_append_sheet(workbook, accountsWoorkSheet, con.ACCOUNTS_SHEET_NAME);
      
      downloadWorkBook(workbook, constructFileName(con.TRANSACTIONS_SHEET_NAME, con.XLSX_FILE_TYPE))
      createNotification("Entradas Descargadas")
    }

  return (
    <div>
        <div className="columnParameterBox">                    
                  <FormGroup label={"Flujos Actuales"}>
                    <Button text={"Descargar Excel"} icon="download" onClick={(e) => downloadCurrentLine()}/>
                  </FormGroup>                  
              </div>
    </div>
  )
}

export default TransactionsDownload